<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

import { CountTo } from "vue3-count-to";

import axios from 'axios';

// import {
//     columnStackedChart,
// } from "./data";

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        

      title: "Dashboard",
      items: [
        {
          text: "Dashboard",
          href: "/",
        }
      ],

      stat:[],
      statSeed:true,

        PendingGrading:[],
        PendingGradingSeen:true,
        
        fieldsPendingGrading:[
            {
                key: "orderId",
                // sortable: true,
                label: "Order No"
            },
            {
                key: "quotation_number",
                // sortable: true,
                label: "Quotation No"
            },
            {
                key: "ComName",
                // sortable: true,
                label: "Company Name"
            },
            {
                key: "totalPrice",
                // sortable: true,
                label: "Total Amount"
            },
            {
                key: "order_date",
                // sortable: true,
                label: "Order Date"
            },
        ],
        perPagePG: 5,
        currentPagePG: 1,

        PendingPayment:[],
        PendingPaymentSeen:true,
        fieldsPendingPayment: [
            {
                key: "orderId",
                // sortable: true,
                label: "Order No"
            },
            {
                key: "po_number",
                // sortable: true,
                label: "PO No"
            },
            {
                key: "ComName",
                // sortable: true,
                label: "Company Name"
            },
            {
                key: "totalPrice",
                // sortable: true,
                label: "Total Amount"
            },
            {
                key: "order_date",
                // sortable: true,
                label: "Order Date"
            },
        ],
        
        perPagePo: 5,
        currentPagePo: 1,
        role:localStorage.getItem('role'),


        //chart
        DeviceTransSeen:false,
        series: '',
        chartOptions: {
            chart: {
                type: "bar",
                height: 350,
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: "bottom",
                        offsetX: -10,
                        offsetY: 0,
                    },
                },
            }, ],
            xaxis: {
                categories: '',
            },
            fill: {
                opacity: 1,
            },
            legend: {
                position: "right",
                offsetX: 0,
                offsetY: 50,
            },
        },



        OrderLineSeen:false,
        seriesLine:'',
        chartOptionsLine: {
            chart: {
                height: 380,
                type: "line",
                zoom: {
                    enabled: true,
                },
                toolbar: {
                    show: false,
                },
            },
            
            dataLabels: {
                enabled: false,
            },
            stroke: {
                width: [3, 3],
                curve: "straight",
            },

            title: {
                text: "",
                align: "left",
                style: {
                    fontWeight: 500,
                },
            },
            grid: {
                row: {
                    colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
                    opacity: 0.2,
                },
                borderColor: "#f1f1f1",
            },
            markers: {
                style: "inverted",
                size: 6,
            },
            xaxis: {
                categories: '',
                title: {
                    text: "Month ",
                },
            },
            yaxis: {
                title: {
                    text: "Orders",
                },
                min: 5,
                max: 40,
            },
            legend: {
                position: "top",
                horizontalAlign: "right",
                floating: true,
                offsetY: -25,
                offsetX: -5,
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart: {
                            toolbar: {
                                show: false,
                            },
                        },
                        legend: {
                            show: false,
                        },
                    },
                },
            ],
        },
        //end chart
    };
  },

    methods: {
        getStat(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'GetAllTotalOrder')
            .then(response => {
                if (response) {
                    if(response.data.status=='error'){
                        this.messageBag = response.data.msj;
                        this.statSeed=false;
                    }else{
                        this.stat = response.data;
                        console.log(this.stat);
                        this.statSeed=false;
                    }
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.RiderSeen=false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.RiderSeen=false;
            });
        },

        GetPendingGrading(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'ListPendingGrading')
            .then(response => {
                if (response) {
                    this.PendingGrading = response.data;
                    this.PendingGradingSeen=false;
                    
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.PendingGradingSeen=false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.PendingGradingSeen=false;
            });
        },

        GetPendingPayment(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'ListPendingPayment')
            .then(response => {
                if (response) {
                    this.PendingPayment = response.data;
                    this.PendingPaymentSeen=false;
                    
                    
                } else {
                    this.messageBag = ['No record.'];
                    this.PendingPaymentSeen=false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.PendingPaymentSeen=false;
            });
        },


        //chart
        GetDevicesTrans(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'DeviceTransaction')
            .then(response => {
                if (response) {
                    // this.DevicesTrans = response.data;
                    this.chartOptions.xaxis.categories = response.data.categories;
                    this.series = response.data.series;

                    this.DeviceTransSeen = true;
                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },

        GetOrderLine(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'TotalMonlyOrderLine')
            .then(response => {
                if (response) {
                    // this.DevicesTrans = response.data;
                    this.chartOptionsLine.xaxis.categories = response.data.categories;
                    this.seriesLine = response.data.series;

                    this.OrderLineSeen = true;
                } else {
                    this.messageBag = ['No record.'];
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
            });
        },
        //end of chart

    },

    mounted() {
        if(this.role == 3){
            this.getStat();

            this.GetPendingPayment();
        }else if(this.role == 5){
            this.$router.push('/price_checker'); 
        }else{
            
            this.GetDevicesTrans();
            this.GetOrderLine();
            this.getStat();
            this.GetPendingGrading();
            this.GetPendingPayment();
            
        }
	},

  components: {
    CountTo,
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div v-if="role == 1">
            <div class="row" v-if="statSeed">
                <div class="col-xl-3 col-md-6">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="row" v-else>

                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Pending Assign to Rider
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalAssignToRider' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/delivery" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-primary rounded fs-3">
                                        <i class="ri ri-e-bike-2-line text-primary"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->
                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Pending Received Item
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalPendingReceivedItem' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/pendingitem" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-primary rounded fs-3">
                                        <i class="bx bx bx-package text-primary"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>

                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Pending QC Assessment
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalPendingGrading' :duration='5000'></count-to> Orders

                                    </h4>
                                    <router-link to="/order/pendingqc" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-warning rounded fs-3">
                                        <i class="ri ri-shield-check-line text-warning"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Pending Customer Approval
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.pendingApproval' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/customerapproval" class="text-decoration-underline">View </router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-success rounded fs-3">
                                        <i class="ri-bill-line text-success"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->
                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Pending Payment
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalPendingPayment' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/pendingpayment" class="text-decoration-underline">View </router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-info rounded fs-3">
                                        <i class="ri-money-dollar-circle-line text-info"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->

                </div>
                <!-- end col -->

                <div class="col-xl-4 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Total Completed order
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                    <count-to :startVal='0' :endVal='stat.TotalComplete' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/complete" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-success rounded fs-3">
                                        <i class="ri-bill-line text-success"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>

              
                
                <!-- end col -->
            </div>
            <!-- end row-->

            <div class="row">
                <div class="col-xl-12" v-if="PendingGradingSeen">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="col-xl-12" v-else>
                    <div class="card">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">Pending QC Assessment</h4>
                        </div>
                    <!-- end card header -->

                        <div class="card-body">
                            <div class="table-responsive table-card">

                                <b-table striped hover class="table-borderless table-centered align-middle table-wrap mb-0" :items="PendingGrading" :fields="fieldsPendingGrading" :per-page="perPagePG" :current-page="currentPagePG" show-expand >
                                    <template v-slot:cell(orderId)="row">
                                        <router-link :to="'/order/details/'+row.item.id" class="fw-medium link-primary">#{{ row.item.orderId }} </router-link>
                                    </template>

                                    <template v-slot:cell(quotation_number)="row">
                                        <router-link :to="'/order/cq/'+row.item.id" class="fw-medium link-primary">#{{ row.item.quotation_number }} </router-link>
                                    </template>

                                    <template v-slot:cell(totalPrice)="row">
                                        {{ row.item.currency }} {{ row.item.totalPrice.toLocaleString('en-US') }}
                                    </template>
                                </b-table>
                            </div>
                            <br><br>
                            <!-- <b-pagination v-model="currentPagePG" :total-rows="rows" :per-page="perPagePG" aria-controls="my-table"></b-pagination> -->
                        </div>
                    </div>
                    <!-- .card-->
                </div>

                <div class="col-xl-12" v-if="PendingPaymentSeen">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="col-xl-12" v-else>
                    <div class="card">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">Pending Payment</h4>
                        </div>
                    <!-- end card header -->

                        <div class="card-body">
                            <div class="table-responsive table-card">


                                <b-table striped hover class="table-borderless table-centered align-middle table-wrap mb-0" :items="PendingPayment" :fields="fieldsPendingPayment" :per-page="perPagePo" :current-page="currentPagePo" show-expand >
                                    <template v-slot:cell(orderId)="row">
                                        <router-link :to="'/order/details/'+row.item.id" class="fw-medium link-primary">#{{ row.item.orderId }} </router-link>
                                    </template>

                                    <template v-slot:cell(po_number)="row">
                                        <span v-if="row.item.po_number">
                                            <router-link :to="'/order/po/'+row.item.id" class="fw-medium link-primary">#{{ row.item.po_number }} </router-link>
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>
                                    <template v-slot:cell(totalPrice)="row">
                                        {{ row.item.currency }} {{ row.item.totalPrice.toLocaleString('en-US') }}
                                    </template>
                                </b-table>
                                
                            </div>
                            <br><br>
                            <!-- <b-pagination v-model="currentPagePo" :total-rows="rows" :per-page="perPagePo" aria-controls="my-table"></b-pagination> -->
                        </div>
                    </div>
                    <!-- .card-->
                </div>

                <div class="col-xl-6">

                    <div class="card">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">Devices Transaction</h4>
                        </div>
                        <div class="card-body" v-if="DeviceTransSeen">
                            <apexchart
                            class="apex-charts"
                            height="350"
                            dir="ltr"
                            :series="series"
                            :options="chartOptions"
                            ></apexchart>
                        </div>
                        <div v-else>
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title mb-0">Monthly Orders</h4>
                        </div>
                        <!-- end card header -->
                        <div class="card-body" v-if="OrderLineSeen">
                            <apexchart
                            class="apex-charts"
                            height="350"
                            dir="ltr"
                            :series="seriesLine"
                            :options="chartOptionsLine"
                            ></apexchart>
                        </div>
                        <div v-else>
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                <!--end card-->
                </div>

                
            </div>
        </div>
        <div v-else>
            <div class="row" v-if="statSeed">
                <div class="col-xl-3 col-md-6">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="row" v-else>

                <!-- mr allo -->

                <div class="col-xl-3 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0 text-wrap">
                                        Scheduled collection/inspection
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalPendingGrading' :duration='5000'></count-to> Orders

                                    </h4>
                                    <router-link to="/order/status/3" class="text-decoration-underline">View</router-link> <br>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-warning rounded fs-3">
                                        <i class="ri ri-shield-check-line text-warning"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <br>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->

                <div class="col-xl-3 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Pending Final Quotation
                                    </p>
                                </div> <br><br>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.pendingPoApproval' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/status/5" class="text-decoration-underline">View </router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-primary rounded fs-3">
                                        <i class="ri ri-e-bike-2-line text-primary"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->

                <div class="col-xl-3 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                    Pending Payment Order
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                        <count-to :startVal='0' :endVal='stat.TotalPendingPayment' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/status/6" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-info rounded fs-3">
                                        <i class="ri-money-dollar-circle-line text-info"></i>
                                    </span>
                                </div>
                            </div>
                        </div><br>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->

                <div class="col-xl-3 col-md-6">
                <!-- card -->
                    <div class="card card-animate">
                        <div class="card-body">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="text-uppercase fw-medium text-muted text-truncate mb-0">
                                        Total Completed order
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                    <count-to :startVal='0' :endVal='stat.TotalComplete' :duration='5000'></count-to> Orders
                                    </h4>
                                    <router-link to="/order/status/7" class="text-decoration-underline">View</router-link>
                                </div>
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title bg-soft-success rounded fs-3">
                                        <i class="ri-bill-line text-success"></i>
                                    </span>
                                </div>
                            </div>
                        </div><br>
                    <!-- end card body -->
                    </div>
                <!-- end card -->
                </div>
                <!-- end col -->

                
            </div>
            <!-- end row-->
            <div class="row">
                <div class="col-xl-12" v-if="PendingPaymentSeen">
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="col-xl-12" v-else>
                    <div class="card">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1">List Pending PO Approval</h4>
                        </div>
                    <!-- end card header -->

                        <div class="card-body">
                            <div class="table-responsive table-card">


                                <b-table striped hover class="table-borderless table-centered align-middle table-wrap mb-0" :items="PendingPayment" :fields="fieldsPendingPayment" :per-page="perPagePo" :current-page="currentPagePo" show-expand >
                                    <template v-slot:cell(orderId)="row">
                                        <!-- <router-link :to="'/order/details/'+row.item.id" class="fw-medium link-primary"></router-link> -->
                                        #{{ row.item.orderId }} 
                                    </template>

                                    <template v-slot:cell(po_number)="row">
                                        <span v-if="row.item.po_number">
                                            <router-link :to="'/order/po/'+row.item.id" class="fw-medium link-primary">#{{ row.item.po_number }} </router-link>
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>
                                    <template v-slot:cell(totalPrice)="row">
                                        {{ row.item.currency }} {{ row.item.totalPrice.toLocaleString('en-US') }}
                                    </template>
                                </b-table>
                                
                            </div>
                            <br><br>
                            <!-- <b-pagination v-model="currentPagePo" :total-rows="rows" :per-page="perPagePo" aria-controls="my-table"></b-pagination> -->
                        </div>
                    </div>
                    <!-- .card-->
                </div>
            </div>
        
        </div>
    </Layout>
</template>